module.exports = __webpack_public_path__ + "post-listing-block-5-overlay@2x-2pwef3i.png";